<template>
    <div class="all">
        <!-- 筛选 -->
        <div class="screen clearfix">
            <div class="fl">
                <div class="corm fr clearfix">
                    <router-link class="element" :to="{path:''+$parent.baseUrl+'/presentationCenter'}">简报列表</router-link>
                    <router-link class="element" :to="{path:''+$parent.baseUrl+'/ordinaryTemplate'}">自定义简报模板</router-link>
                    <router-link class="element" :to="{path:''+$parent.baseUrl+'/timingTemplate'}">定时报告模板</router-link>
                    <router-link class="element" :to="{path:''+$parent.baseUrl+'/timelyReporting'}">定时报告</router-link>
                    <router-link class="element" :to="{path:''+$parent.baseUrl+'/industryProducts'}">竞品/行业</router-link>
                </div>
            </div>
        </div>
        <div class="warp mt20">
            <div class="warp-body">
                <div class="d-flex">
                    <h4 class="mb20 tttitle">竞品信息</h4>
                    <div class="grid-info fr tips2">
                        <i class="icons icons-question-circle"></i> 
                        <p class="grid-tip">+号表示与关系，|号表示或关系。示例：华为+（手机 | 充电器+数据线），需要监测的数据即为包含华为+手机，或者包含华为+充电器+数据线的文章</p>
                    </div>
                </div>
                <div class="d-flex mb10" v-for="(item,index) in industProducts" :key="index">
                    <div class="hei-lin">
                        <span v-if="index == 0">竞品一:</span>
                        <span v-else-if="index == 1">竞品二:</span>
                        <span v-else-if="index == 2">竞品三:</span>
                        <span v-else-if="index == 3">竞品四:</span>
                        <span v-else>竞品五:</span>
                    </div>
                    <div class="d-flex ml10">
                        <input type="text" class="input-text width130 height50" placeholder="请输入竞品名称" v-model="industProducts[index].name">
                        <div class="centerline">--------</div>
                        <textarea type="text" class="textArea" si placeholder="请输入竞品关键词" v-model="industProducts[index].keywordsInit"></textarea>
                    </div>
                    <i class="del cup ml10" v-if="industProducts.length > 1" @click="delMonitorInput(index);">&times;</i>
                </div>
                <div class="mt10 clearfix input-father mb20 " style="width:400px">
                    <button class="btn btns fl" @click="addMonitorInput();"><i class="icons add-icon1"></i><span class="color-blue">添加竞品</span></button>
                    <p class="input-tips fr">（最多支持5组竞品）</p>
                </div>
                <div class="d-flex">
                    <h4 class="mb20 tttitle">行业信息</h4>
                    <div class="grid-info fr tips2">
                        <i class="icons icons-question-circle"></i> 
                        <p class="grid-tip">+号表示与关系，|号表示或关系。示例：华为+（手机 | 充电器+数据线），需要监测的数据即为包含华为+手机，或者包含华为+充电器+数据线的文章</p>
                    </div>
                </div>
                <div class="d-flex" v-for="(items,indexs) in industryList" :key="`tem${indexs}`">
                    <div class="hei-lin">行业:</div>
                    <div class="d-flex ml10">
                        <input type="text" class="input-text width130 height50" placeholder="请输入行业名称" v-model="industryList[indexs].name">
                        <div class="centerline">--------</div>
                        <textarea type="text" class="textArea" si placeholder="请输入行业关键词" v-model="industryList[indexs].keywordsInit"></textarea>
                    </div>
                </div>
            </div>
            <div class="form-btn">
                <div class="p40">
                    <button class="btn save btn-jbblue" @click="industSave();">保存</button>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import {mapState} from 'vuex';
export default {
    computed:{
        ...mapState({
            // platformList: state => state.show.platformList
        })
    },
    data() {
        return {
            sid:'',
            industProducts:[
                {
                    id:'',
                    keywordsInit:'',
                    name:''
                }
            ],
            industryList:[
                {
                    id:'',
                    keywordsInit:'',
                    name:''
                }
            ]
        }
    },
    components:{
        
    },
    created() {
		// 获取缓存方案数据
        this.sid = JSON.parse(sessionStorage.getItem('planStorage')).id;
        console.log('this.sid',this.sid)
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
            this.getIndeustlist();
        })
    },
    watch:{
        
    },
    beforeDestroy() {

    },
    methods: {
        //获取竞品信息
        getIndeustlist(){
            let that = this;
            that.$api.get('report/compete-industry/info',{sid:this.sid},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.compete.length>0){
                        let industProducts = [];
                        for(let item of r.data.compete){
                            let arr = {
                                id:item.id,
                                keywordsInit:item.keywordsInit,
                                name:item.name
                            }
                            industProducts.push(arr);
                        }
                        that.industProducts = industProducts;
                    }
                    if(r.data.industry.length>0){
                        let industryList = [];
                        for(let item of r.data.industry){
                            let arr = {
                                id:item.id,
                                keywordsInit:item.keywordsInit,
                                name:item.name
                            }
                            industryList.push(arr);
                        }
                        that.industryList = industryList;
                    }        
                });
            });
        },
        addMonitorInput(){
            if(this.industProducts.length >= 5){
                this.$utils.alertText('竞品最多添加5组',200);
                return;
            }
            let arr = {
                id:'',
                name:'',
                keywordsInit:''
            }
            this.industProducts.push(arr);
        },
        //删除竞品
        delMonitorInput (index) {
            let that = this;
            let industProducts = that.industProducts;
            industProducts.splice(index,1);
        },
        //保存信息
        industSave(){
            let that = this;
            //过滤掉不正常的竞品数据
            for(let item of this.industProducts){
                item.keywordsInit = item.keywordsInit.replace(/（/g, '(').replace(/）/g, ')');
                // if(item.name == ''||item.keywordsInit==''){
                //     this.$utils.alertText('请补全竞品信息',200);
                //     return false;
                // }
            }
            for(let item of this.industryList){
                item.keywordsInit = item.keywordsInit.replace(/（/g, '(').replace(/）/g, ')');
                // if(item.name == ''||item.keywordsInit==''){
                //     this.$utils.alertText('请补全行业信息',200);
                //     return false;
                // }
            }
            let parms = {
                sid:this.sid,
                compete:this.industProducts,
                industry:this.industryList
            }
            that.$api.post('report/compete-industry/edit',parms,r=>{
                that.$parent.returnCode(r,function(){
                    that.$utils.alertText('提交成功',200);
                });
            });
        }
	}
}
</script>
<style scoped>
    
</style>




// WEBPACK FOOTER //
// src/page/yuqingFenxi/presentation/industryProducts.vue